import { render } from "./PreLoader.vue?vue&type=template&id=6c64b6e7&ts=true"
import script from "./PreLoader.vue?vue&type=script&lang=ts"
export * from "./PreLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__